import { render, staticRenderFns } from "./Servizi.vue?vue&type=template&id=075fa3c3&"
import script from "./Servizi.vue?vue&type=script&lang=ts&"
export * from "./Servizi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports